var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg404 = function Svg404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 755 680"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "404_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: ".036%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "404_svg__b",
    x1: "50%",
    x2: "50%",
    y1: "99.957%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "404_svg__c",
    x1: "49.993%",
    x2: "49.993%",
    y1: "100.005%",
    y2: "-.002%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "404_svg__d",
    x1: "50.021%",
    x2: "50.021%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "31%",
    stopColor: "#FCCC63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77%",
    stopColor: "#F55F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "404_svg__e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "31%",
    stopColor: "#FCCC63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77%",
    stopColor: "#F55F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "404_svg__f",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "31%",
    stopColor: "#FCCC63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77%",
    stopColor: "#F55F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "404_svg__g",
    x1: "49.972%",
    x2: "49.972%",
    y1: "99.913%",
    y2: "-.087%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "404_svg__h",
    x1: "50.289%",
    x2: "50.289%",
    y1: "99.999%",
    y2: ".187%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "54%",
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "gray",
    stopOpacity: 0.1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#37A3BC",
    fillOpacity: 0.85,
    fillRule: "nonzero",
    d: "M827.448 590.858a116.68 116.68 0 0 1-23.105-.308c-84.346-9.326-199.205-6.673-292.835 51.34-129.489 80.217-332.422 11.544-421.94-25.816C21.17 587.538-14.339 517.647 6.99 452.044c.3-.926.609-1.852.934-2.778 13.421-38.987 39.913-69.499 72.719-85.672 28.594-14.097 70.341-43.533 88.917-100.095 7.674-23.355 18.2-45.326 31.872-64.478 36.61-51.29 113.249-127.67 245.057-127.197a212.491 212.491 0 0 1 67.905 11.496c48.154 16.408 91.645 49.764 124.81 96.008 21.162 29.494 52.875 56.912 98.276 59.147 63.01 3.12 123.141 32.456 168.25 84.664a387.862 387.862 0 0 1 3.871 4.537c80.318 95.682 24.532 253.857-82.153 263.182z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.061,
    cy: 11.936,
    r: 11.511,
    fill: "url(#404_svg__a)",
    fillRule: "nonzero",
    opacity: 0.7,
    transform: "translate(220.208 558.027)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 232.269,
    cy: 569.964,
    r: 10.994,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.253,
    cy: 345.443,
    r: 4.254,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.873,
    cy: 592.343,
    r: 4.254,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.537,
    cy: 614.03,
    r: 2.377,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 684.905,
    cy: 285.386,
    r: 2.377,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245.323,
    cy: 206.145,
    r: 4.254,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M128.405 493.975h-3.787v-3.787h-1.543v3.787h-3.787v1.543h3.787v3.779h1.543v-3.779h3.787zm95.09-1.668h-3.787v-3.787h-1.544v3.787h-3.786v1.543h3.786v3.779h1.544v-3.779h3.787zm135.961 76.739h-3.787v-3.787h-1.543v3.787h-3.787v1.543h3.787v3.779h1.543v-3.779h3.787zm189.371-460.018H547.1v-1.727h-.7v1.727h-1.727v.701h1.727v1.726h.7v-1.726h1.727zm100.929 261.914h-1.727v-1.726h-.701v1.726h-1.726v.701h1.726v1.726h.701v-1.726h1.727zM59.198 436.004h-1.727v-1.727h-.701v1.727h-1.726v.7h1.726v1.727h.701v-1.727h1.727zm70.9 141.8h-1.727v-1.726h-.7v1.726h-1.727v.701h1.727v1.727h.7v-1.727h1.727zm222.71-447.923h-1.726v-1.727h-.701v1.727h-1.727v.701h1.727v1.726h.701v-1.726h1.726zM247.709 379.283h-1.727v-1.726h-.7v1.726h-1.727v.701h1.727v1.727h.7v-1.727h1.727zm22.521-71.734h-1.726v-1.727h-.701v1.727h-1.727v.701h1.727v1.726h.701v-1.726h1.726z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.135,
    cy: 9.718,
    r: 9.609,
    fill: "url(#404_svg__b)",
    fillRule: "nonzero",
    opacity: 0.7,
    transform: "translate(614.748 453.762)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 624.882,
    cy: 463.48,
    r: 8.9,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 648.846,
    cy: 526.13,
    r: 9.951,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#404_svg__c)",
    fillRule: "nonzero",
    d: "M242.705 256.1a129.1 129.1 0 0 0-14.598-60.056c-4.58-8.709-8.758-14.114-11.978-17.442a8.548 8.548 0 0 0-9.792-1.885 8.864 8.864 0 0 0-3.429 2.21c-4.345 4.505-8.274 10.46-11.677 16.791a129.644 129.644 0 0 0-15.323 61.725v12.912h-8.283v-150.15c0-31.463-7.04-62.5-20.853-90.026-6.54-13.046-12.512-21.154-17.091-26.134a11.848 11.848 0 0 0-17.809 0c-6.205 6.749-11.81 15.674-16.682 25.158-14.505 28.126-21.87 60.056-21.87 92.437v148.657h-7.157V256.76a129.633 129.633 0 0 0-15.323-61.683c-3.429-6.331-7.357-12.287-11.678-16.79a8.568 8.568 0 0 0-10.01-1.82l.3.16a8.954 8.954 0 0 0-2.793 1.951c-3.212 3.337-7.39 8.733-11.97 17.442A129.103 129.103 0 0 0 .09 256.075v224.379h25.56l-2.82 18.442v55.16h20.904v-55.16l-2.794-18.45h25.19v-204.36h7.157V479.56h20.41l-2.927 19.335v55.16h20.903v-55.16l-2.928-19.36h27.526l-2.944 19.36v55.16h20.903v-55.16l-2.928-19.36H167.6V276.111h8.283v204.668h6.715v-.308h22.204l-2.786 18.425v55.16h20.903v-55.16l-2.794-18.45h22.58V256.1z",
    opacity: 0.7,
    transform: "translate(316.966)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535461",
    fillRule: "nonzero",
    d: "M364.845 488.17h-19.794l3.537-24.031h12.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M347.604 473.681h14.689l-.984-6.715h-12.721z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535461",
    fillRule: "nonzero",
    d: "M534.463 488.17h-19.785l3.528-24.031h12.729z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M517.222 473.681h14.697l-.984-6.715h-12.729z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535461",
    fillRule: "nonzero",
    d: "M429.155 488.17H409.37l3.528-24.031h12.729z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M411.914 473.681h14.698l-.985-6.715h-12.728z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535461",
    fillRule: "nonzero",
    d: "M469.444 488.17h-19.786l3.529-24.031h12.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M452.202 473.681H466.9l-.993-6.715h-12.72z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535461",
    fillRule: "nonzero",
    d: "M364.845 265.543h141.35v5.655h-141.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    fillRule: "nonzero",
    d: "M528.04 176.225a7.966 7.966 0 0 0-11.811 0c-4.112 4.387-7.832 10.184-11.077 16.349a129.093 129.093 0 0 0-14.505 60.056v217.573h62.559v-218.49a128.641 128.641 0 0 0-13.821-58.505c-4.346-8.475-8.3-13.78-11.344-16.983zm-179.394 0a7.966 7.966 0 0 1 11.811 0c4.12 4.387 7.833 10.184 11.086 16.349a129.206 129.206 0 0 1 14.505 60.056v217.573H323.49v-218.49a128.641 128.641 0 0 1 13.821-58.505c4.338-8.475 8.292-13.78 11.336-16.983z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#535461",
    fillRule: "nonzero",
    d: "m323.848 256.351 14.847.075v18.3h-14.847zm47.353 0 14.847.075v18.3h-14.847zm119.446 0 14.839.075v18.3h-14.839zm47.353 0 14.839.075v18.3H538z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M371.543 192.29c-3.253-6.164-6.965-11.961-11.086-16.349a7.93 7.93 0 0 0-9.45-1.776 8.416 8.416 0 0 1 2.385 1.776c4.112 4.388 7.833 10.185 11.077 16.349a129.074 129.074 0 0 1 14.506 60.057v217.555h7.073V252.355a129.196 129.196 0 0 0-14.505-60.065zm139.265.6c3.244-6.164 6.965-11.96 11.077-16.348a8.28 8.28 0 0 1 2.736-1.952 7.958 7.958 0 0 0-9.092 1.952c-4.12 4.387-7.841 10.184-11.086 16.349a129.206 129.206 0 0 0-14.505 60.056v217.59h6.364V252.963a129.083 129.083 0 0 1 14.506-60.073z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#404_svg__d)",
    fillRule: "nonzero",
    d: "M355.219 541.887h-.542c-5.316 0-9.626-4.31-9.626-9.626V488.17h19.794v44.091a9.624 9.624 0 0 1-9.626 9.626z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#404_svg__e)",
    fillRule: "nonzero",
    d: "M419.538 541.887h-.55c-5.313-.005-9.618-4.313-9.618-9.626V488.17h19.785v44.091a9.626 9.626 0 0 1-9.617 9.626zm40.28 0h-.56c-5.305-.014-9.6-4.32-9.6-9.626V488.17h19.786v44.091c0 5.316-4.31 9.626-9.626 9.626z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#404_svg__f)",
    fillRule: "nonzero",
    d: "M524.846 541.887h-.526a9.626 9.626 0 0 1-9.642-9.626V488.17h19.785v44.091a9.626 9.626 0 0 1-9.617 9.626z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "nonzero",
    d: "M446.197 5.63a11.012 11.012 0 0 0-16.858 0c-5.839 6.573-11.177 15.256-15.848 24.498-13.73 27.393-20.703 58.49-20.703 90.019v349.171h89.25V118.746c0-30.638-6.672-60.891-19.718-87.667-6.13-12.703-11.778-20.602-16.123-25.449z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.577,
    height: 21.345,
    x: 413.549,
    y: 44.417,
    fill: "#535461",
    fillRule: "nonzero",
    rx: 10.673
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M393.271 132.083h88.342v3.428h-88.342z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#404_svg__g)",
    fillRule: "nonzero",
    d: "M635.634 259.687a28.875 28.875 0 0 0-8.525-7.507 28.636 28.636 0 1 0-14.322 53.442c.61 0 1.218 0 1.81-.067a28.626 28.626 0 0 0 21.045-45.818l-.008-.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M639.846 276.937c-.002 14.283-11.102 26.106-25.357 27.009-.559 0-1.134.058-1.71.058a27.075 27.075 0 0 1-17.415-47.821 27.075 27.075 0 0 1 30.953-2.693 27.173 27.173 0 0 1 8.057 7.14 26.938 26.938 0 0 1 5.472 16.307z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M606.114 259.762a29.156 29.156 0 0 0-4.037 2.127 6.348 6.348 0 0 0-2.16 1.935 2.5 2.5 0 0 0-.05 2.761c.659.901 1.927 1.035 3.044 1.101 1.174.15 2.366.03 3.487-.35a7.486 7.486 0 0 0 2.035-1.476l2.327-2.11c.835-.735 1.669-1.744 1.343-2.778a2.502 2.502 0 0 0-1.977-1.335 8.278 8.278 0 0 0-5.838 1.026",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.668,
    cy: 1.518,
    r: 1.426,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1,
    transform: "translate(594.729 286.104)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.605,
    cy: 5.839,
    r: 5.222,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1,
    transform: "translate(619.752 272.758)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M634.424 260.63a7.123 7.123 0 1 1-8.066-7.14 27.154 27.154 0 0 1 8.066 7.14zm.484 31.888a27 27 0 0 1-20.42 11.428c0-.376-.05-.751-.05-1.135a12.831 12.831 0 0 1 20.47-10.293z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#404_svg__h)",
    fillRule: "nonzero",
    d: "M265.885 414.208a20.15 20.15 0 0 0-5.956-5.272 20.019 20.019 0 1 0-10.01 37.286c.426 0 .835 0 1.268-.042a20.02 20.02 0 0 0 14.681-31.972h.017z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M268.82 426.244c-.001 9.965-7.746 18.214-17.691 18.843h-1.193a18.883 18.883 0 0 1-17.741-12.427 18.883 18.883 0 0 1 27.183-22.814A18.897 18.897 0 0 1 265 414.85a18.775 18.775 0 0 1 3.82 11.394z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M245.282 414.266c-.976.416-1.916.91-2.811 1.477a4.624 4.624 0 0 0-1.51 1.351 1.775 1.775 0 0 0 0 1.927c.56.553 1.334.833 2.119.767.82.106 1.652.023 2.435-.242a5.233 5.233 0 0 0 1.427-1.034l1.618-1.468c.567-.517 1.184-1.218.934-1.935a1.669 1.669 0 0 0-1.376-.934 5.727 5.727 0 0 0-4.062.717",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.61,
    cy: 1.618,
    r: 1,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1,
    transform: "translate(236.89 432.075)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.304,
    cy: 3.67,
    r: 3.645,
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.1,
    transform: "translate(254.407 423.734)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M265.009 414.867a5.005 5.005 0 1 1-5.631-5.005 18.892 18.892 0 0 1 5.63 5.005zm.367 22.246a18.844 18.844 0 0 1-14.247 7.974v-.834a8.95 8.95 0 0 1 14.28-7.182l-.033.042z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m699.569 449.942 18.184 9.676-14.197 15.881"
  }))));
};
export default Svg404;